import { render, staticRenderFns } from "./IssueCheck.vue?vue&type=template&id=aeefacfe&scoped=true"
import script from "./IssueCheck.vue?vue&type=script&lang=js"
export * from "./IssueCheck.vue?vue&type=script&lang=js"
import style0 from "./IssueCheck.vue?vue&type=style&index=0&id=aeefacfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeefacfe",
  null
  
)

export default component.exports